import {MESSAGE_COMPANY_ID, MESSAGE_HOST} from "../../helper/host";

export const HttpClient = (url, method, data) => {
    const token = localStorage.getItem("Presensi-message-token");

    const requestData = { ...data, companyID : MESSAGE_COMPANY_ID}

    const headers = {
        'Accept': 'application/json',
    };

    if (method !== 'GET') {
        headers['Content-Type'] = 'application/json';
    }

    if (token) {
        headers['Authorization'] = 'Bearer ' + token;
    }

    return fetch(MESSAGE_HOST + url, {
        method,
        headers,
        body: method !== 'GET' ? JSON.stringify(requestData) : undefined,
    })
        .then(response => {
            if (!response.ok) {
                return response.json().then(err => {
                    throw new Error(err.message || `HTTP error ${response.status}`);
                });
            }
            return response.json();
        })
        .catch(error => {
            console.error('requestMessage error:', error);
            throw error;
        });
};